export let APP_ENV = {};

export const setAppEnv = env => {
  APP_ENV = { ...APP_ENV, ...env };
};

export const getAppEnv = key => {
  return APP_ENV[key];
};
